import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Linkedin, Facebook } from 'lucide-react';

const LOGO_FULL = "https://customer-assets.emergentagent.com/job_secure-parcels/artifacts/9xfoqgv2_LOKKER%20PRINCIPAL.png";

export const Footer = () => {
  return (
    <footer className="bg-lokker-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img src={LOGO_FULL} alt="Use Lokker" className="h-12 w-auto" />
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Armários inteligentes para recebimento e retirada facilitada de encomendas. 
              Praticidade, segurança e autonomia para você.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" className="text-white/60 hover:text-lokker-lime transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-white/60 hover:text-lokker-lime transition-colors" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-white/60 hover:text-lokker-lime transition-colors" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-lokker-lime">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/planos" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-planos">
                  Planos
                </Link>
              </li>
              <li>
                <Link to="/condominios" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-condominios">
                  Para Condomínios
                </Link>
              </li>
              <li>
                <Link to="/empresas" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-empresas">
                  Para Empresas
                </Link>
              </li>
              <li>
                <Link to="/mapa" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-mapa">
                  Mapa de Lockers
                </Link>
              </li>
            </ul>
          </div>

          {/* Institucional */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-lokker-lime">Institucional</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-sobre">
                  Sobre Nós
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-trabalhe">
                  Trabalhe Conosco
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-termos">
                  Termos de Uso
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-privacidade">
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-link-faq">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-lokker-lime">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <Mail className="w-4 h-4 text-lokker-lime" />
                <span>contato@uselokker.com.br</span>
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <Phone className="w-4 h-4 text-lokker-lime" />
                <span>(11) 99999-9999</span>
              </li>
              <li className="flex items-start gap-3 text-white/70 text-sm">
                <MapPin className="w-4 h-4 text-lokker-lime mt-0.5" />
                <span>Rio Branco, Ac - Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Use Lokker. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/50 hover:text-white text-sm transition-colors">
              Termos
            </a>
            <a href="#" className="text-white/50 hover:text-white text-sm transition-colors">
              Privacidade
            </a>
            <a href="#" className="text-white/50 hover:text-white text-sm transition-colors">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
